export default "./dist/stdassets/images/icons/layer_add.png";